export default {
  PROJECT_TYPE_NEW:'0',
  PROJECT_TYPE_RENEW: '1',

  // 项目基本信息弹窗页面操作类型 详情、新增、编辑、续保
  PROJECT_OPERATION_TYPE_DETAIL: '0',
  PROJECT_OPERATION_TYPE_ADD: '1',
  PROJECT_OPERATION_TYPE_EDIT: '2',
  PROJECT_OPERATION_TYPE_RENEW: '3',

  PROJECT_PURCHASE_RESULT_TYPE_OK:'1', // 正常中标
  PROJECT_PURCHASE_RESULT_TYPE_REJECT:'0', // 废标

  OSS_ADR_TEMPLATE:'https://ja-001.oss-cn-qingdao.aliyuncs.com/project/bms/template/'
}